// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/opencode.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const OPENCODE_MODELS: ModelCatalog<typeof values, "opencode"> =
	flattenModelCatalog("opencode", values);
